import type { ITabProps } from 'BreetHelpers';
import { useState } from 'react';

export const useTab = <T extends string>(defaultTab: T): ITabProps<T> => {
	const [activeTab, setActiveTab] = useState<T>(defaultTab);

	const isActiveTab = (tabItem: T) => tabItem === activeTab;

	return {
		activeTab,
		setActiveTab,
		isActiveTab,
	};
};
